import unescapedText from 'I18n/utils/unescapedText';
import { AccordionItem } from 'foundations-components/transitional/components/AccordionItem';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { useTrackMarketplaceEvent } from 'marketplace-ui-tracking';
import { getMarketplaceInteractionEvent } from 'marketplace-ui-tracking/events/marketplace';
import styled from 'styled-components';
import { PolymorphicLink } from 'trellis-ecosystem';
import { Paths } from '../../constants/paths';
import { getTemplateMarketplaceUrl } from '../../utils/urls';
import { useAppContext } from '../../context/AppContext';
import getLang from 'I18n/utils/getLang';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function StorefrontNav() {
  const appContext = useAppContext();
  const lang = getLang();
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      sm: false
    }
  });
  return /*#__PURE__*/_jsx("nav", {
    "aria-label": "Marketplace navigation",
    children: isMobile ? /*#__PURE__*/_jsx(AccordionItem, {
      title: unescapedText('marketplaceStorefront.storefrontNav.browse'),
      size: "sm",
      children: /*#__PURE__*/_jsxs(List, {
        children: [/*#__PURE__*/_jsx(StorefrontNavLink, {
          href: Paths.AGENTS,
          label: unescapedText('marketplaceStorefront.storefrontNav.agents'),
          linkMode: "react-router",
          eventType: "AGENT"
        }), /*#__PURE__*/_jsx(StorefrontNavLink, {
          href: Paths.APPS,
          label: unescapedText('marketplaceStorefront.storefrontNav.apps'),
          linkMode: "react-router",
          eventType: "APP"
        }), /*#__PURE__*/_jsx(StorefrontNavLink, {
          href: getTemplateMarketplaceUrl(appContext, lang),
          label: unescapedText('marketplaceStorefront.storefrontNav.templates'),
          linkMode: "default",
          eventType: "theme"
        }), /*#__PURE__*/_jsx(StorefrontNavLink, {
          href: Paths.SOLUTIONS_PARTNERS,
          label: unescapedText('marketplaceStorefront.storefrontNav.solutionsPartners'),
          linkMode: "react-router",
          eventType: "solution provider"
        })]
      })
    }) : /*#__PURE__*/_jsxs(List, {
      inline: !isMobile,
      gap: "1000",
      children: [/*#__PURE__*/_jsx(StorefrontNavLink, {
        href: Paths.AGENTS,
        label: unescapedText('marketplaceStorefront.storefrontNav.agents'),
        linkMode: "react-router",
        eventType: "AGENT"
      }), /*#__PURE__*/_jsx(StorefrontNavLink, {
        href: Paths.APPS,
        label: unescapedText('marketplaceStorefront.storefrontNav.apps'),
        linkMode: "react-router",
        eventType: "APP"
      }), /*#__PURE__*/_jsx(StorefrontNavLink, {
        href: getTemplateMarketplaceUrl(appContext, lang),
        label: unescapedText('marketplaceStorefront.storefrontNav.templates'),
        linkMode: "default",
        eventType: "theme"
      }), /*#__PURE__*/_jsx(StorefrontNavLink, {
        href: Paths.SOLUTIONS_PARTNERS,
        label: unescapedText('marketplaceStorefront.storefrontNav.solutionsPartners'),
        linkMode: "react-router",
        eventType: "solution provider"
      })]
    })
  });
}
const StyledLinkText = styled.div.withConfig({
  displayName: "StorefrontNav__StyledLinkText"
})(["padding-block-start:", ";&:hover{text-decoration:underline;}"], ({
  theme
}) => theme.space['100']);
function StorefrontNavLink({
  href,
  label,
  linkMode,
  eventType
}) {
  const trackMarketplaceEvent = useTrackMarketplaceEvent();
  const trackStorefrontNavLinkClicked = type => {
    trackMarketplaceEvent(getMarketplaceInteractionEvent({
      action: 'storefront nav link clicked',
      type
    }));
  };
  return /*#__PURE__*/_jsx(ListItem, {
    children: /*#__PURE__*/_jsx(PolymorphicLink, {
      href: href,
      onClick: () => trackStorefrontNavLinkClicked(eventType),
      linkMode: linkMode,
      use: "unstyled",
      children: /*#__PURE__*/_jsx(StyledLinkText, {
        children: label
      })
    })
  });
}